/**
 * True when a project has a usable KML file configured.
 * Treats empty, whitespace, and the Setup UI's "None" placeholder as missing.
 */
export function projectHasKml (datasetInfo) {
	if (!datasetInfo) {
		return false;
	}
	const kml = datasetInfo.Kml;
	if (kml == null) {
		return false;
	}
	const value = String(kml).trim();
	return value !== '' && value.toLowerCase() !== 'none';
}
